<template>
	<div id="main-wrapper"  :class="[this.$store.state.is_teacher ? null : 'sidebar-hide' ]" >
		<Nav   :datos-nav="datosNav"  />
		<SideBar  v-if="!$store.state.flagPostulant" :datos-sidebar="datosSidebar"  />
		<modalTimeZone/>
		<div class="content-body" :class="[$store.state.flagPostulant ? 'content-body-left' : '', $router.history.current.name == 'chat' ? 'bg_chat' : '']">
				<div class="container-fluid">
						<slot />
				</div>
		</div>
		<NotificationBox ref="refNotification"/>
		<Footer v-if="!($router.history.current.name == 'chat')" :class="[$store.state.flagPostulant ? 'content-body-left' : '']" />
		<ModalDevice ref="modalDevice"/>
	</div>
</template>


<script>
import Nav from '@/components/navs';
import SideBar from '@/components/sidebar';
import Footer from "@/components/footer";
import NotificationBox from "@/components/notifications/index.vue"
import AuthenticationMixin from '@/assets/js/authenticationMixin.js';
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import * as Constants from "@/assets/js/appConstants";
import { getTimeZoneNameUser } from '@/assets/js/util.js';
import modalTimeZone from "@/components/modals/modal-time-zone";
import ModalDevice from '@/components/modals/device'
import { DEVICE } from '@/assets/js/appConstants';
	

import * as firebase from "firebase/app";
import "firebase/messaging";

export default {
	components: {
		Nav,
		SideBar,
		Footer,
		modalTimeZone,
		NotificationBox,
		ModalDevice
	},
	mixins: [AuthenticationMixin],
	data() {
		return {
			datosSidebar : {
				typeScheduled:0,
				flagPurchaseHistory:null,
				flagActivePlan:null,
				flagEdited : false,
			},
			datosNav:{
				nroNotifications:0
			},
			isDesktop: window.innerWidth > DEVICE.DESKTOP,
		}
	},
	computed: {
		UserId: {
				get() {
						return this.$store.state.user_id;
				},
		},
		User: {
				get() {
					return this.$store.state.user;
				},
				set(value) {
                	this.$store.commit('mutateUser', value);
            	}
		},
		FlagViewModalTimeZone: {
			get(){
				return this.$store.state.flagViewModalTimeZone;
			}
		}
	},
	created(){
		 
		//setear lang
		if(localStorage.getItem('lang') == null){
			localStorage.setItem('lang', "es");
			this.$i18n.locale = "es";
		}

		if(this.User != null){
			let currentTimeZoneName = getTimeZoneNameUser();
			// Never offer to overwrite the timezone during an admin "login as student/teacher"
			// session -- the browser here is the admin's, not the account owner's, so a
			// mismatch is expected and clicking through would silently save the admin's own
			// location onto the real user's profile.
			if(this.User.timeZoneName != currentTimeZoneName && this.FlagViewModalTimeZone && !this.$store.state.is_admin){
				setTimeout(() => {this.$bvModal.show("modal-time-zone")}, 100);
			}
		}
		
		if(this.$store.state.is_teacher){
			this.datosNav.nroNotifications = this.$route.params.totalNotifications;
		}
		
		/*if(this.$router.history.current.name == 'chat') {
			document.getElementsByClassName
		}*/
	},
	mounted(){
		//console.log('ROUTER',this.$router.history.current.name)
		 
		if(this.$router.history.pending == null && this.$router.history.current.fullPath == "/"){
			//this.$router.push({ path: `/compra/0` });
			if(this.User != null){
				this.getDatosGenerales();
			}
			this.logoRedireccion(false);
		}else if(this.$router.history.pending == null  || 
				!(this.$router.history.pending.name == "edad" 
					||  this.$router.history.pending.name == "login"
					||  this.$router.history.pending.name == "index"
					||  this.$router.history.pending.name == "teacher/login"
					||  this.$router.history.pending.name == "student/login"
					||  this.$router.history.pending.name == ""
				)
		)
		{
			this.validarSesion();
			if(this.User != null){
				this.getDatosGenerales();
			}	
		}

		//console.log("layout_FCM: ", firebase.default.messaging.isSupported());
		if(firebase.default.messaging.isSupported() && this.User && !this.$store.state.is_admin){
			this.GenerateFCMToken();
			this.receiveMessage();
		}
	},
	methods: {
		GenerateFCMToken(){
			try{
				if (Notification.permission !== "denied") {
					Notification.requestPermission().then(function (permission) {
						if (permission === "granted") {
							return firebase.default.messaging().getToken();
						}
					}).then((token) => {
						//console.log(token);
						if(token && this.User.fCM_Token !== token){
							this.UpdateFCMToken(token);
						}
					}).catch((error) => {
						console.log('Unable to get token', error)
					});
				}
			}catch(ex){
				console.log(ex);
			}
		},
		receiveMessage() {
            try {
                firebase.default.messaging().onMessage((payload) => {
					this.datosNav.nroNotifications = parseInt(payload.data.totalNotifications, 10);
					// const {title, username, message} = payload.data;
					// this.$refs.refNotification.setNotificationBoxForm(title, username, message);
                });
            } catch (e) {
                console.log(e);
            }
        },
		getDatosGenerales(){		
			if(!this.$store.state.is_teacher){
			
				let json = {
					GroupsId: this.User.groupId != null ? this.User.groupId : 0,
					PersonId: this.User.id,
					PersonStudentId: this.User.personStudentId,
					Page: 0,
					Size: 0,
					TypeSearch: false
				};
				 
				baseInstanceAxios
					.post(`${this.apiURL}/resources/dashboard/GetDataGeneral`, json)
					.then((response) => {
						
						if(response.data != null){
							if(response.data.entity != null ){
								//DATOS GENERALES DEL SIDEBAR

								if(!this.isDesktop  && response.data.entity.flagPurchaseHistory){
									this.showModalDevice();
								}
						
								// this.$store.commit("mutateUpdateFlagSubject",response.data.entity.flagSubjectsShow);
								if(response.data.entity.flagPurchaseHistory){
									if(!response.data.entity.flagViewMenuOptions){
											this.$store.commit("mutateUpdateFlagSubject",response.data.entity.flagSubjectsShow);
									}
								}
								
								if(response.data.entity.entityGroupScheduleProposal != null){
									let scheduleValue = response.data.entity.entityGroupScheduleProposal.tipoHorarioProgramado;
									this.datosSidebar.flagEdited = response.data.entity.entityGroupScheduleProposal.flagChangeTeacher;


									this.$store.state.user.groupScheduleStundentId = response.data.entity.entityGroupScheduleProposal.groupScheduleStundentId
								 	if(this.datosSidebar.flagEdited){
										if(scheduleValue == 0){
											this.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.MASS_REQUEST;
											this.$store.commit("mutateDatosSidebar",this.datosSidebar);				
										}else{
											switch (scheduleValue) {
												case Constants.TYPE_SCHEDULED.UNPROGRAMMED:
														this.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.UNPROGRAMMED;
														this.$store.commit("mutateDatosSidebar",this.datosSidebar);
													break;
												case Constants.TYPE_SCHEDULED.MASS_REQUEST:
														this.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.MASS_REQUEST;
														this.$store.commit("mutateDatosSidebar",this.datosSidebar);
													break;
												case Constants.TYPE_SCHEDULED.DIRECT_REQUEST:
														this.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.DIRECT_REQUEST;
														this.$store.commit("mutateDatosSidebar",this.datosSidebar);
													break;
												case Constants.TYPE_SCHEDULED.SCHEDULED:
														this.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.SCHEDULED;
														this.$store.commit("mutateDatosSidebar",this.datosSidebar);
													break;
											}
										}
									}else{
											switch (scheduleValue) {
												case Constants.TYPE_SCHEDULED.UNPROGRAMMED:
														this.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.UNPROGRAMMED;
														this.$store.commit("mutateDatosSidebar",this.datosSidebar);
													break;
												case Constants.TYPE_SCHEDULED.MASS_REQUEST:
														this.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.MASS_REQUEST;
														this.$store.commit("mutateDatosSidebar",this.datosSidebar);
													break;
												case Constants.TYPE_SCHEDULED.DIRECT_REQUEST:
														this.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.DIRECT_REQUEST;
														this.$store.commit("mutateDatosSidebar",this.datosSidebar);
													break;
												case Constants.TYPE_SCHEDULED.SCHEDULED:
														this.datosSidebar.typeScheduled = Constants.TYPE_SCHEDULED.SCHEDULED;
														this.$store.commit("mutateDatosSidebar",this.datosSidebar);
													break;
											}
									}
								
									this.$store.commit('mutateIsRepresentative', response.data.entity.flagGroupRepresentative);
								}

								//DATOS GENERALES DEL NAV
								if(response.data.entity.listNotifications != null){
									if(response.data.entity.listNotifications.value == 0){
										this.datosNav.nroNotifications = response.data.entity.listNotifications.rows;
									}

								}

								/* COMENTADO POR AHORA, NO BORRAR*/
								
								this.datosSidebar.flagPurchaseHistory = response.data.entity.flagPurchaseHistory;
								this.datosSidebar.flagActivePlan = response.data.entity.flagActivePlan;
								this.datosSidebar.flagViewMenuOptions = response.data.entity.flagViewMenuOptions;
								
								//this.datosSidebar.flagPurchaseHistory = true;
								//this.datosSidebar.flagActivePlan = true;
								//this.datosSidebar.flagViewMenuOptions = true;
								

								this.$store.commit('mutateDatosSidebar', this.datosSidebar);
								this.$store.commit('mutateGroupId',response.data.entity.groupId);
								this.$store.commit('mutateIsGroup',response.data.entity.flagGroup);
								this.$store.commit('mutateGroupPersonId',response.data.entity.groupPersonId);
							
								//this.logoRedireccion(this.datosSidebar.flagPurchaseHistory);
						
								if(this.$route.path == "" || this.$route.path == "/"){
										
									this.logoRedireccion(this.datosSidebar.flagPurchaseHistory);
								}
							}
						}
					});
			} else{
				let json = {
					PersonId: this.User.id,
					Page: 0,
					Size: 0,
					TypeSearch: false
				};

				baseInstanceAxios
					.post(`${this.apiURL}/resources/dashboard/GetDataTeacherGeneral`, json)
					.then((response) => {
						
						if(response.data != null){
							if(response.data.entity != null ){
								//DATOS GENERALES DEL NAV
								if(response.data.entity.listNotifications != null){
									if(response.data.entity.listNotifications.value == 0){
										this.datosNav.nroNotifications = response.data.entity.listNotifications.rows;
									}
								}

								if(this.$store.state.flagPostulant){ //SI NUNCA HA COMPRADO UN PLAN...
										this.$router.push({ path: `/teacher/account` }).catch(err => {});
								}
							}	
						}
					});
			}
		},
		UpdateFCMToken(newFCMToken){
			const json = {
				id: this.User.id,
				fCM_Token: newFCMToken
			};

			baseInstanceAxios
				.put(`${this.apiURL}/resources/persons/UpdateFCMToken`, json)
				.then(() => {
					this.User.fCM_Token = newFCMToken;
				})
				.catch((error) => {
					console.log(error);
				});
		},
		showModalDevice() {
			this.$bvModal.show("modal-device") 
		}
	}
};
</script>

 